@if (form) {
    <form [fxHide]="Spinner.isShown('initForms')" [formGroup]="form" fxLayout="column" fxLayoutAlign="start start"
          class="w-824 mt-24"
          (submit)="submit()">

        <div fxLayout="column" fxLayoutAlign="start start" class="w-100 mt-24">
            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelTrendDescription' | translate }}*</div>
            <mat-form-field class="mt-4 w-100" [class.value-not-empty]="form.enabled && form.value.description">
                <textarea matInput
                          #descriptionArea
                          [maxlength]="500"
                          class="resize-none pt-12 pb-12"
                          (keydown.control.enter)="submit()"
                          [placeholder]="'i18n_af_placeholderTrendDescription' | translate"
                          formControlName="description"></textarea>
                <mat-hint align="start" class="t5 c-primary-gray-600">{{ descriptionArea.value.length }} / {{ DESCRIPTION_MAX_LENGTH }}
                </mat-hint>
                @if (form.controls.description?.hasError('minlength')) {
                    <mat-error class="c-secondary-red-900">
                        {{ 'i18n_af_fieldValidationDescriptionMinLength' | translate: {min: DESCRIPTION_MIN_LENGTH} }}
                    </mat-error>
                }
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayoutAlign="start start" class="w-100 mt-24">
            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelTrendKeywords' | translate }}*</div>
            <mat-form-field class="mt-4 w-100" [class.value-not-empty]="form.enabled && form.value.keywords">
                <textarea matInput
                          #keywordsArea
                          [maxlength]="500"
                          class="resize-none pt-12 pb-12"
                          (keydown.control.enter)="submit()"
                          [placeholder]="'i18n_af_placeholderTrendKeywords' | translate"
                          formControlName="keywords"></textarea>
                <mat-hint align="start" class="t5 c-primary-gray-600">{{ keywordsArea.value.length }} / {{ DESCRIPTION_MAX_LENGTH }}
                </mat-hint>
                @if (form.controls.keywords?.hasError('minlength')) {
                    <mat-error class="c-secondary-red-900">
                        {{ 'i18n_af_fieldValidationDescriptionMinLength' | translate: {min: DESCRIPTION_MIN_LENGTH} }}
                    </mat-error>
                }
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayoutAlign="start start" class="w-100 mt-24">
            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelTrendConclusion' | translate }}*</div>
            <mat-form-field class="mt-4 w-100" [class.value-not-empty]="form.enabled && form.value.conclusion">
                <textarea matInput
                    #conclusionArea
                    [maxlength]="500"
                    class="resize-none pt-12 pb-12"
                    (keydown.control.enter)="submit()"
                    [placeholder]="'i18n_af_placeholderTrendConclusion' | translate"
                    formControlName="conclusion"></textarea>
                    <mat-hint align="start" class="t5 c-primary-gray-600">{{ conclusionArea.value.length }} / {{ DESCRIPTION_MAX_LENGTH }}
                </mat-hint>
                @if (form.controls.conclusion?.hasError('minlength')) {
                    <mat-error class="c-secondary-red-900">
                        {{ 'i18n_af_fieldValidationDescriptionMinLength' | translate: {min: DESCRIPTION_MIN_LENGTH} }}
                    </mat-error>
                }
            </mat-form-field>
        </div>


        <div fxLayout="row" fxLayoutAlign="start center" class="mt-40">
            <ui-kit-button spinnerId="submit"
                           [disabled]="form.invalid"
                           [label]="'i18n_af_buttonNext' | translate"/>
            <ui-kit-button class="ml-16"
                           color="accent"
                           buttonType="button"
                           type="text"
                           (clickListener)="cancel.emit()"
                           [label]="'i18n_af_buttonCancel' | translate"/>
        </div>
    </form>
}
